import { Space, Statistic } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Contract, ContractStatusEnum } from '../../../api'
import { useRebateOptimizerAccess } from '../../../common/hooks/useRebateOptimizerAccess'
import { ContractTags } from '../../Contracts/components/ContractStatusTag'

const ContractDateFormat = new Intl.DateTimeFormat('en', { month: 'short', day: '2-digit', year: 'numeric' })

export const ContractCard: React.FC<{ contract: Contract }> = ({ contract }) => {
  const { contractsLite } = useRebateOptimizerAccess()
  // Rebate-Optimizer-only users have no contract details page — send the card to the edit workflow (#7206).
  const contractCardLink =
    contract.status === ContractStatusEnum.Draft
      ? `/analytics/contracts/create/${contract.id}`
      : contractsLite
      ? `/analytics/contracts/${contract.id}/update`
      : `/analytics/contracts/${contract.id}`
  return (
    <ContractListItemCard>
      <ContractTitleWrapper>
        <ContractTitle to={contractCardLink}>{contract.name}</ContractTitle>
        <Space>
          <ContractTags contract={contract} />
        </Space>
      </ContractTitleWrapper>
      <ContractInfoWrapper>
        <Statistic style={{ minWidth: 0 }} title="Contract #" formatter={v => v} value={contract.code} />
        <Statistic title="Supplier" value={contract.supplier} />
        <Statistic title="Pricing Tiers" value={contract.numTiers || ''} />
        <Statistic title="Expiration Date" value={ContractDateFormat.format(new Date(contract.activeDue))} />
      </ContractInfoWrapper>
    </ContractListItemCard>
  )
}

const ContractInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  .ant-statistic-content-value {
    width: 100%;
    word-wrap: break-word;
  }
`

const ContractListItemCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 32px 20px 32px;
  background: #fff;
  margin-bottom: 8px;
  border-radius: 4px;
`

const ContractTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 8px;
  text-wrap: nowrap;
`

const ContractTitle = styled(Link)`
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 32px;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #2164c4;
`
